import type {EntryPoint} from 'react-relay'
import type {LoaderFunctionArgs} from 'react-router'
import {getRequest} from 'relay-runtime'

import {isPipelinesEnabledInExclusiveMode} from '../../../../utils/featureToggles'

import type {AddRepositoryPageComponent} from './AddRepositoryPage'
import {query} from './AddRepositoryPage.queries'

import {makeResource} from 'src/utils/makeResource'

export const AddRepositoryPageEntryPoint: EntryPoint<
  AddRepositoryPageComponent,
  LoaderFunctionArgs
> = {
  root: makeResource(
    'AddRepositoryPage',
    () => import(/* webpackChunkName: "AddRepositoryPage" */ './AddRepositoryPage'),
  ),
  getPreloadProps: ({params}) => ({
    queries: {
      main: {
        parameters: getRequest(query),
        variables: {locator: `id:${params.pipelineId}`, skip: isPipelinesEnabledInExclusiveMode()},
      },
    },
  }),
}
